import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref, h } from 'vue'
import { blacklist, editData } from '@/api/gucangSales/blackList'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import { listByParamCodes } from '@/api/common'
import type { BlackFindByPageBackData } from '@/typings/api/gucangSale'
import CustomerSelect from '@/components/ClueAndCustomerSelect/src/customer.vue'
const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<BlackFindByPageBackData>({})
const emit = __emit
const toggle = (row?: BlackFindByPageBackData) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const getBlackReason = async () => {
  try {
    const res = await listByParamCodes({
      appId: 'cos_fbu',
      paramCodes: ['fbu_black_reason']
    })
    return res.data.fbu_black_reason
  } catch (error) {
    console.log('getBlackReason error: ', error)
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    editForm.value.appId = 'cos_fbu'
    try {
      if (editForm.value.id) {
        await editData(editForm.value)
      } else {
        await blacklist(editForm.value)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_CosApiSelect = _resolveComponent("CosApiSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
    title: 
      h('div', { class: 'title-box' }, [
        h('div', { class: 'title-div' }, editForm.value.id ? '编辑' : '新增'),
        h('span', { class: 'title-span' }, '（拉黑后，客户负责人将不能对客户进行跟进及合作）')
      ])
    ,
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "refId",
                label: "客户名称/代码:",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(CustomerSelect, {
                    value: editForm.value.refId,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.refId) = $event)),
                    appId: "cos_fbu",
                    label: editForm.value.customerName,
                    "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.customerName) = $event)),
                    placeholder: "请选择"
                  }, null, 8, ["value", "label"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "blacklistReason",
                label: "拉黑原因:",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosApiSelect, {
                    api: getBlackReason,
                    "show-search": "",
                    mode: "tags",
                    optionFilterProp: "label",
                    value: editForm.value.blacklistReason,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.blacklistReason) = $event)),
                    fieldNames: { label: 'name', value: 'id' }
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "blacklistRemark",
                label: "备注:"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosTextarea, {
                    value: editForm.value.blacklistRemark,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.blacklistRemark) = $event)),
                    placeholder: "请输入",
                    "auto-size": { minRows: 2, maxRows: 5 },
                    maxlength: 500
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})